import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d57fdda2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "plans" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "plan-header" }
const _hoisted_6 = { class: "plan-name" }
const _hoisted_7 = { class: "plan-dur" }
const _hoisted_8 = { class: "plan-desc" }
const _hoisted_9 = { class: "parts" }
const _hoisted_10 = { class: "operation" }
const _hoisted_11 = ["onClick"]

import {withDefaults, onMounted} from 'vue'
import ScheduleRecorded from "@/pages/Schedule/components/ScheduleRecorded.vue";
import ScheduleLive from "@/pages/Schedule/components/ScheduleLive.vue";
import useDateConvert from "@/composables/useDateConvert";
import {CoursePlanPartVO, CoursePlanVO} from "@/apis/course";
import {useRouter} from "vue-router";
import {Calendar, ArrowRightBold} from '@element-plus/icons'
import {ElEmpty} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleContent',
  props: {
    courseId: { default: 0 },
    plans: { default: () => [] },
    currentPlan: {}
  },
  setup(__props: any) {

const prop = __props

const router = useRouter();
const {convertDatetime} = useDateConvert()

const typeMap = {
  RECORDED: ScheduleRecorded,
  LIVE: ScheduleLive,
  PROJECT: ScheduleRecorded,
  EXAM: ScheduleRecorded,
}

const handleClick = (part: CoursePlanPartVO, plan: CoursePlanVO) => {
  router.push({
    path: `/main/${prop.courseId}`,
    query: {
      planId: plan.id,
      partId: part.id
    }
  })
}

onMounted(() => {
  if (!window.location.href.includes("#") && prop.currentPlan?.id) {
    window.location.href = window.location.href + "#content" + prop.currentPlan.id
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.plans.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(ElEmpty), {
              description: "暂无内容",
              "image-size": "300"
            })
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.plans, (plan) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "plan",
              key: 'content'+plan.id,
              id: 'content'+plan.id
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(plan.planName), 1),
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_unref(Calendar), { class: "icon" }),
                  _createTextVNode(" " + _toDisplayString(_unref(convertDatetime)(plan.startTime, 'YYYY年MM月DD日') + ' - ' + _unref(convertDatetime)(plan.endTime, 'YYYY年MM月DD日')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(plan.planDesc), 1),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.parts, (part) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "part",
                    key: 'part'+part.id
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(typeMap[part.type]), {
                      class: "info",
                      part: part,
                      key: 'part-com'+part.id
                    }, null, 8, ["part"])),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "btn",
                        onClick: ($event: any) => (handleClick(part, plan))
                      }, [
                        _createVNode(_unref(ArrowRightBold), { class: "icon" })
                      ], 8, _hoisted_11)
                    ])
                  ]))
                }), 128))
              ])
            ], 8, _hoisted_4))
          }), 128))
    ])
  ]))
}
}

})